import React, { useMemo, forwardRef, useImperativeHandle, useEffect } from "react";
import { Form } from "@bedrock/components";
import classNames from 'classnames/bind'
import SettlementStatementFormModal from '@mpc/common/src/features/SettlementStatementFormModal';
import { useControllableValue, useUpdateEffect } from 'ahooks'
import styles from './index.less'
import { InvoiceDetailDto, OutsourceDemandDetailsResDtoAttachmentDto } from "#services/api";
import { localPx2rem } from "#utils";

const cx = classNames.bind(styles)

type Value = {
    invoice_belong_area?: number,
    is_oversea_invoice?: boolean,
    invoice_list?: InvoiceDetailDto[],
    signed_statement_attachs?: OutsourceDemandDetailsResDtoAttachmentDto[],
}

type Props = {
    value?: Value,
    onChange?: (value) => void,
    detail?: any
    view?: boolean
    showInvoiceSource?: boolean
    isHideInvoice?: boolean
}

const Index = (props: Props, ref) => {
    const { detail, view = false, showInvoiceSource = false, isHideInvoice } = props
    const [form] = Form.useForm()
    const { validateFields, getFieldsValue } = form
    const [formData, setFormData] = useControllableValue(props, {
        defaultValue: {
            invoice_belong_area: undefined,
            is_oversea_invoice: undefined,
            invoice_list: [],
            signed_statement_attachs: [],
        }
    })

    useEffect(() => {
        form.setFieldsValue(formData)
    }, [formData])


    // 编辑信息发生变化时，清空发票列表
    // 详情态不执行
    useUpdateEffect(() => {
        if (!view) {
            setFormData({ ...formData, invoice_list: [] })
        }
    }, [formData.invoice_belong_area, formData.is_oversea_invoice, view])

    const handleValuesChange = (values, allValue) => {
        if (!!values?.invoice_belong_area) {
            if (values?.invoice_belong_area !== 1) {
                form.setFieldValue('is_oversea_invoice', true)
                setFormData({ ...allValue, is_oversea_invoice: true })
            } else {
                form.setFieldValue('is_oversea_invoice', false)
                setFormData({ ...allValue, is_oversea_invoice: false })
            }
        } else {
            setFormData({ ...allValue })
        }
    }

    useImperativeHandle(ref, () => {
        return {
            validateFields,
            getFieldsValue,
        }
    })
    const items = useMemo(() => {
        const item = [
            {
                formItemKey: 'invoice_belong_area',
            },
            {
                formItemKey: 'is_oversea_invoice',
            },
            {
                formItemKey: 'invoice_list',
                elementProps: {
                    showInvoiceSource,
                },
            },
            {
                formItemKey: 'signed_statement_attachs',
            },
        ]
        return item
    }, [])

    useUpdateEffect(() => {
        if (isHideInvoice) {
            form.setFieldsValue({
                invoice_belong_area: undefined,
                is_oversea_invoice: undefined,
                invoice_list: [],
            })
        }
    }, [isHideInvoice])

    if (detail?.non_need_fee_control_verify) {
        return null
    }

    return (
        <Form
            form={form}
            showLabelColon
            layout="vertical"
            onValuesChange={handleValuesChange}
            initialValues={{
                whether_overseas: 0
            }}>
            <SettlementStatementFormModal
                renderType="descriptions"
                globalItemProps={{
                    view,
                }}
                renderData={{
                    formData,
                    detailData: {...detail, $isHideInvoice: isHideInvoice}
                }}
                descriptionsProps={{
                    labelStyle: {
                        width: localPx2rem(148),
                    }
                }}
                row={{
                    gutter: [24, 0],
                }}
                itemCols={items as any}
            />
        </Form>
    )
}

export default forwardRef(Index);